import { useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Btn, H4, H5, Image, P } from "../../../../../../AbstractElements";
import { PrintModalProps } from "../../../../../../Types/Contact.type";
import { dynamicImage } from "../../../../../../Utils";
import { PrintPreview } from "../../../../../../Utils/Constants";

export default function PrintModal({ printModal, selectedUser, toggleCallback }: PrintModalProps) {
  const contentRef = useRef<HTMLDivElement>(null);
  const handlePrint = useReactToPrint({ contentRef });
  const printModalToggle = () => {
    toggleCallback(false);
  };
  return (
    <Modal className="modal-bookmark" isOpen={printModal} toggle={printModalToggle} centered>
      <ModalHeader toggle={printModalToggle}>{PrintPreview}</ModalHeader>
      <ModalBody className="list-persons">
        <div className="profile-mail pt-0" ref={contentRef}>
          <div className="common-flex align-items-center">
            <Image className="img-fluid rounded-circle" src={dynamicImage(selectedUser.avatar)} alt="" />
            <div className="flex-grow-1 mt-0">
              <H4>
                <span>{selectedUser.name}</span>
                <span>{selectedUser.surname}</span>
              </H4>
              <P>{selectedUser.email}</P>
            </div>
          </div>
          <div className="email-general">
            <H5>{"General"}</H5>
            <P>
              {"Email Address"} :
              <span className="font-primary" id="mailadd">
                {selectedUser.email}
              </span>
            </P>
          </div>
        </div>

        <Btn color="success" className="me-1" onClick={() => handlePrint()}>
          {"Print"}
        </Btn>

        <Btn color="primary" onClick={printModalToggle}>
          {"Cancel"}
        </Btn>
      </ModalBody>
    </Modal>
  );
}
